
import React, { Component, Fragment } from 'react';
import { base_url } from '../../globalConstants'
import { Table, Row, Col, Image, Nav, ButtonGroup, Button } from 'react-bootstrap';
import M from "materialize-css";
import { EditOutlined } from "@material-ui/icons";
import Axios from 'axios';
// import AddCountry from './CountryModal';
import './addSlab.css';



class AddCashBillingSetup extends Component {

  constructor(props) {
    super(props);
    //order_id,ezz_id__name,box_id__outbound_tracking_number,box_id__shipped_on,fedEx_rated_weight,unit_charge,processing,brokerage

//orderid,customer name,AWB No,ShippedOn,Weight,Price,Proccessing,Brokerage
    this.state = ({
      countryName: "", rangeInitial: "", rangeFinal: "",
      unitCharge: "", markup: "", 
      slabdata: this.props.slabdata, 
      countrylist: this.props.countrylist, 
      countrycodelist: this.props.country_code_list, error: "",
      countryId:"", mainId:"", keyId:"", editRow: false,arrform: [],
      productsList : [
        { value: "order_id", label: "Order No", isChecked: false},
        { value: "ezz_id__name", label: "Customer Name", isChecked: false },
        { value: "box_id__outbound_tracking_number", label: "AWB No", isChecked: false },
        { value: "box_id__shipped_on", label: "Shipped On", isChecked: false },
        { value: "remark", label: "Order Remarks", isChecked: false },
        { value: "fedEx_rated_weight", label: "Weight", isChecked: false },
        { value: "unit_charge", label: "Price", isChecked: false },
        { value: "processing", label: "Consolidation Fee", isChecked: false },
        // { value: "9", label: "Create Coupon", isChecked: false },
        // { value: "10", label: "View Coupon", isChecked: false }
      ]
    })
    

  }

  onAddingItem = (i) => (event) => {
    this.setState((state, props) => {
      state.productsList[i].isChecked = !state.productsList[i].isChecked;
      state.isedit = true;
      return {
        productsList: state.productsList
      }
    })
  }

  handleCountryNameChange = (e) => {

    let selected_countryName = this.state.countrycodelist[this.state.countrylist.indexOf(e.target.value)]

    this.setState({ countryName: e.target.value})
    this.setState({ countryId: selected_countryName})
  }

  handleRangeInitialChange = (e) => {
    this.setState({ rangeInitial: e.target.value })
  }

  handleRangeFinalChange = (e) => {
    this.setState({ rangeFinal: e.target.value })
  }
  handleUnitchargeChange = (e) => {
    this.setState({ unitCharge: e.target.value })
  }
  handleMarkupChange = (e) => {
    this.setState({ markup: e.target.value })
  }


//EDIT OPTION START
handleEditOption = (e) => {
  this.setState({editRow:true})
  var elems = document.getElementById("addSlabModal");
  var instance = M.Modal.init(elems);
  instance.open()

  let selectedRowIndex ;
              e = e || window.event;
              var data = [];
              var target = e.srcElement || e.target;
              // console.log(target.nodeName)
              while (target && target.nodeName !== "TR") {
                  target = target.parentNode;
                  selectedRowIndex= target.sectionRowIndex
                  console.log("Clicked row",target.sectionRowIndex)
                  // console.log(target.parentNode.index)
              }
              if (target) {
                  var cells = target.getElementsByTagName("td");
                  for (var i = 0; i < cells.length; i++) {
                      data.push(cells[i].innerHTML);
                  }
              }
              //alert(data[8])
              const arrform = data[8] ? data[8].split(",") : [];

  // Update checkbox state based on arrform
  const updatedProductsList = this.state.productsList.map(product => ({
    ...product,
    isChecked: arrform.includes(product.value)
  }));
              let country_name = this.state.countrylist[this.state.countrycodelist.indexOf(data[5])]
              // let country_name = this.state.countrylist[this.state.countrycodelist.indexOf(data[3])]
              
              this.setState({editRowNumer: selectedRowIndex})
              console.log(selectedRowIndex);
              this.setState({mainId: data[0], keyId: data[7]})
              this.setState({
                rangeInitial: data[1], rangeFinal: data[2], 
                unitCharge: data[3], markup: data[4],
                countryName: country_name,
                arrform :data[8].split(","),
                productsList: updatedProductsList
              })
              console.log(data);
              // console.log(country_name);
              console.log(data[5]);

}
openAddSlabDetailsModal =  ()=>{
  const resetProductsList = this.state.productsList.map(product => ({
    ...product,
    isChecked: false
  }));

  this.setState({editRow:false})
  this.setState({error :""})
  this.setState({
    countryName: "", rangeInitial: "", rangeFinal: "",
    unitCharge: "", markup: "", arrform: [],
    productsList: resetProductsList 
  })
//again reset the state for add to slab
  var elems = document.getElementById("addSlabModal");
  var instance = M.Modal.init(elems);
  instance.open()
    
}
closeModal = ()=>{
  var elems = document.getElementById("addSlabModal");
  var instance = M.Modal.init(elems);
  instance.close();
  this.setState({editRow:false})
  this.setState({error :""})
  this.setState({ countryName: "", rangeFinal: "", rangeInitial: "", unitCharge: "", markup: "" })

}
updateSlabDetailsDB = async () => {
  const checkedItems = this.state.productsList.filter(item => item.isChecked);
  const scheck1 = checkedItems.map(item => item.value).join(",");
  const displayLabels = checkedItems.map(item => item.label).join(",");

  let country_code = this.state.countrycodelist[this.state.countrylist.indexOf(this.state.countryName)]
  let url = base_url+`cashbillingsetup/${this.state.keyId}/`

  // console.log(this.state.statename + this.state.statecode + this.state.countryname)
  var slabformdata = new FormData()
  slabformdata.append("country", country_code)
  slabformdata.append("range_initial", this.state.rangeInitial)
  slabformdata.append("range_final", this.state.rangeFinal)
  slabformdata.append("unit_charge", this.state.unitCharge)
  slabformdata.append("credit_limit", this.state.markup)
  slabformdata.append("status", "Active")
  slabformdata.append("display_column", displayLabels)
  slabformdata.append("db_column", scheck1)


  // @Todo: APi to be called to save data for state

  try {
    let token = localStorage.getItem("token")
    var config = {
      headers: { 'Content-Type': 'multipart/form-data' , 'Authorization':'Token '+token},
      
    };
    const response = await Axios.put(url, slabformdata, config)

    let itemIndex = parseInt(this.state.mainId) - 1
    this.state.slabdata.splice(itemIndex, 1, response.data)    
    
    // this.state.slabdata.unshift(response.data)
    var elem = document.getElementById('addSlabModal')
    var instance = M.Modal.getInstance(elem);
    instance.close();
    M.toast({ html: 'Updated Cash Billing Setup Successfully.' , classes: "white-text orange rounded" })
    this.setState({ countryName: "", rangeFinal: "", rangeInitial: "", unitCharge: "", markup: "" })

    this.setState({
      error: "",
      editRow: false
    })
  } catch (err) {
    this.setState({
      error: "OH Snap! Something is Wrong.Please try again",
      editRow: false
    })
    M.toast({ html: 'Please Try Again!', classes: "white-text red rounded" });

    console.log(err.message)
  }

}
//EDIT OPTION END


  addSlabToDB = async () => {
  const checkedItems = this.state.productsList.filter(item => item.isChecked);
  const scheck1 = checkedItems.map(item => item.value).join(",");
  const displayLabels = checkedItems.map(item => item.label).join(",");

//   alert("Selected Values: " + scheck1);
//   alert("Display Labels: " + displayLabels);
//   return
//     var markedCheckbox = document.querySelectorAll('input[type="checkbox"]:checked');
//   var scheck = "";
// for (var checkbox of markedCheckbox) {
//   if (scheck.length == 0)
//   {
//   scheck = checkbox.value;
// }
// else
// {
//   scheck = scheck + ',' + checkbox.value;
// }
  
// }
// alert(scheck);
// return
    let country_code = this.state.countrycodelist[this.state.countrylist.indexOf(this.state.countryName)]

    var slabformdata = new FormData()
    slabformdata.append("country", country_code)
    slabformdata.append("range_initial", this.state.rangeInitial)
    slabformdata.append("range_final", this.state.rangeFinal)
    slabformdata.append("unit_charge", this.state.unitCharge)
    slabformdata.append("credit_limit", this.state.markup)
    slabformdata.append("status", "Active")
    slabformdata.append("display_column",displayLabels)
    slabformdata.append("db_column",scheck1)
 var context = this
  
      let token = localStorage.getItem("token")
      var config = {
        headers: { 'Content-Type': 'multipart/form-data' , 'Authorization':'Token '+token},
        
      };
      var elem = document.getElementById('addSlabModal')
      var instance = M.Modal.getInstance(elem);
       Axios.post(base_url+'cashbillingsetup/', slabformdata, config)
      .then(function(response){
        context.state.slabdata.unshift(response.data)

        
        instance.close();
        context.setState({ countryName: "", rangeFinal: "", rangeInitial: "", unitCharge: "", markup: "" })
        M.toast({ html: 'Added Cash Billing Setup Successfully! Please see Updated Table', classes: "white-text orange rounded" })
      }).catch(function(response){
        // console.log(response)
      
      if (response.response.status === 400){
        console.log(response.response.status)
        context.setState({
          error: "Sent Empty fields/bad Request. "
        })
        M.toast({ html: 'Please Try Again!', classes: "white-text red rounded" });
      }
        }) 
      
      

   






      
    // } catch (err) {
    //   this.setState({
    //     error: "OH Snap! Something is Wrong.Please try again"
    //   })
    //   console.log(err.Status)
    //   M.toast({ html: 'Please Try Again!', classes: "white-text red rounded" });


    // }



  }

  componentDidMount() {
    // Auto initialize all the things!
    M.AutoInit();
  }
  render() {
    let {productsList} =  this.state;

    
    var uniquekey = 0
    const selectCounrtyOptions = this.state.countrylist.map((country) => {
      // console.log("countrylist", country)
      return (
        <option className="black-text" key={uniquekey++} value={country}>{country}</option>
      )
    })

    var sr_no=0
    const statetable = this.state.slabdata.map((slab) => {
      sr_no=sr_no+1; 
      return (
        <Fragment key={sr_no}>
          <tr  >
            <td>{sr_no}</td>
            <td>{slab.range_initial}</td>
            <td>{slab.range_final}</td>
            <td>{slab.unit_charge}</td>
            <td>{slab.credit_limit}</td>
            <td>{slab.country}</td>
            <td onClick={this.handleEditOption}><a title = "Edit"><EditOutlined/></a></td>  
            <td className="hide">{slab.id}</td>
            <td className="hide">{slab.db_column}</td>
          </tr>
        </Fragment>

      )
    })

    const table_render = <Table hover >
      <thead>
        <tr>
          <th>Sr.No.</th>
          <th>Range Initial (LBS)</th>
          <th>Range Final (LBS))</th>
          <th>Unit charge</th>
          <th>Credit Limit</th>
          <th>Country</th>
          <th>Edit</th>                 
        </tr>
      </thead>
      <tbody>
        {statetable}

      </tbody>
    </Table>



    return (
      <Fragment>
        <br></br>
        <br></br>
        {/* <div className="">
    <AddCountry ref="child"/>
        </div> */}




        {/* <!-- Modal Trigger --> */}
        <div id="addSlabModal" className="modal modal-fixed-footer_addslab">
          <div className="modal-content" >
          <h4 className="center orange-text"> {this.state.editRow ? "Update Cash Billing Setup Details" : "Add Cash Billing Setup Details "}</h4>

            <Row>
              <Col xs={12} >
                <form>
                  <p className="center red-text">{this.state.error}</p>
                  <Row>
                    <Col className=" rowdivPading " xs={12}>


                      <div className="input-field col s6 offset-s3">
                        <div id=''>
                          {
                            this.state.editRow
                              ? <select id="country_name_selct" name="country_name" className="browser-default country_name_select" value={this.state.countryName} onChange={this.handleCountryNameChange}>
                                <option value="" disabled >Choose Country</option>
                                {selectCounrtyOptions}
                              </select>
                              : <select id="country_name_selct" name="country_name" className="browser-default country_name_select" defaultValue={'DEFAULT'} onChange={this.handleCountryNameChange}>
                                <option value="DEFAULT" disabled >Choose Country</option>
                                {selectCounrtyOptions}
                              </select>
                          }
                          <label>Select Country</label>
                        </div>
                      </div>  
                      </Col>
                  </Row>


                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name-="rangeinitial" id="range_initial" className="materialize-textarea" type="text" value={this.state.rangeInitial} onChange={this.handleRangeInitialChange} />
                        <label htmlFor="range_initial" className={this.state.rangeInitial?"black-text active":"black-text"}>Enter Initial Range</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Lower LBS</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="rangefinal" id="rangel_final" type="text" value={this.state.rangeFinal} onChange={this.handleRangeFinalChange} className="" />
                        <label htmlFor="range_final" className={this.state.rangeFinal?"black-text active":"black-text"}>Enter Final Range</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Upper LBS</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="unitcharge" id="unit_charge" type="text" value={this.state.unitCharge} onChange={this.handleUnitchargeChange} className="" />
                        <label htmlFor="unit_charge" className={this.state.unitCharge?"black-text active":"black-text"}>Enter Unit Charge</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Unit charge</span>
                      </div>
                    </Col>
                  </Row>


                  <Row>
                    <Col className=" rowdivPading ">
                      <div className="input-field col s6 offset-s3 center">
                        <input name="markup" id="mark_up" type="text" value={this.state.markup} onChange={this.handleMarkupChange} className="" />
                        <label htmlFor="mark_up" className={this.state.markup?"black-text active":"black-text"}>Enter Credit Limit</label>
                        <span className="helper-text left" data-error="wrong" data-success="">Credit Limit</span>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col className=" rowdivPading">
                    <div className="input-field col s8 offset-s3 left">
          {/* <div className="col s3">   */}
<div className="container">
      <div className="card">
        <div className="card-header">
          <p className="title">Select Invoice Column/s </p>
        </div>
 
        
 
        <div className="card-body" >
        <div >  
          {/* className="card-body scroll-checkbox-list" */}
        { 
        productsList.map((product, i) =>{
          return(
            <tr key={i+1}>
              <td>{i+1}</td>
              <td></td>
              <td>
                  <div class="checkbox checkbox-circle checkbox-color-scheme">
                      <label class="checkbox-checked">
                          <input type="checkbox" value={product.value} checked={product.isChecked} onChange={this.onAddingItem(i)}/> <span class="label-text">{product.label}</span>
                      </label>
                  </div>
              </td>
          </tr>
          )
        })}
        </div>
        </div>
      </div>
    {/* </div> */}
</div>
</div>
                    </Col>
                  </Row>
                </form>
              </Col>
            </Row>
          </div>
          <div className="modal-footer">
            {/* <a href="#!" className="modal-close waves-effect waves-green btn-flat">Agree</a> */}

            <ButtonGroup className="mr-2" aria-label="First group">
              <Button id='cancelSlabbtn' variant="outline-secondary" className="mr-4 btn modal-close " onClick={this.closeModal} >Cancel</Button>
              {
              this.state.editRow
              ?<Button id="updateSlabBtn" variant="outline-primary" className="mr-2 btn" onClick = {this.updateSlabDetailsDB}>Update</Button>
              :<Button id="addSlabBtn" variant="outline-primary" className="mr-2 btn" onClick={this.addSlabToDB}> Add</Button>
              }   
            </ButtonGroup>

          </div>
        </div>
        <div className="">
          <Row>
            <Col xs={12} md={12} lg={12} >
              <div className="tableheight">
                {table_render}
              </div>
            </Col>

          </Row>
          <Row>
            <Col >

              <Nav className="right">
                <Nav.Link className="red-text modal-trigger " onClick={this.openAddSlabDetailsModal}>
                  Add Cash Billing Setup<Image className="red-text mr-auto" src="assets/images/plus-circle-red-m.svg" /></Nav.Link>
              </Nav>


            </Col>
          </Row>
        </div>


      </Fragment>

    )
  }

}

export default AddCashBillingSetup